import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const sections = [
  {
    title: '1. Objet du service',
    items: [
      'VoucherPro met a disposition une plateforme professionnelle destinee a la gestion de comptes revendeurs, de commandes et de services numeriques.',
      'L acces a certains services reste soumis a validation, a disponibilite operationnelle et a verification interne.'
    ]
  },
  {
    title: '2. Conditions d acces',
    items: [
      'L utilisateur doit fournir des informations exactes lors de l inscription et maintenir ces informations a jour.',
      'La creation d un compte ne garantit pas l activation immediate du service. Les comptes revendeurs peuvent rester en attente de validation administrative.'
    ]
  },
  {
    title: '3. Utilisation autorisee',
    items: [
      'L utilisateur s engage a utiliser la plateforme de maniere legale, loyale et conforme a sa destination professionnelle.',
      'Toute tentative de fraude, d abus, d acces non autorise ou de detournement du service peut entrainer la suspension ou la suppression du compte.'
    ]
  },
  {
    title: '4. Compte et securite',
    items: [
      'L utilisateur est responsable de la confidentialite de ses identifiants et des activites effectuees depuis son compte.',
      'VoucherPro se reserve le droit de suspendre temporairement un compte en cas de risque de securite ou de non-respect des presentes conditions.'
    ]
  },
  {
    title: '5. Paiements, commandes et disponibilite',
    items: [
      'Les prix, soldes, commandes et statuts affiches sur la plateforme peuvent etre soumis a verification, confirmation ou validation interne.',
      'VoucherPro ne peut etre tenu responsable des interruptions temporaires, indisponibilites techniques ou retards lies a des contraintes operationnelles ou a des services tiers.'
    ]
  },
  {
    title: '6. Propriete intellectuelle',
    items: [
      'Les elements visuels, textes, logos, interfaces et contenus de la plateforme restent la propriete de VoucherPro ou de leurs titulaires respectifs.',
      'Aucune reproduction, extraction ou reutilisation non autorisee n est permise sans accord prealable.'
    ]
  },
  {
    title: '7. Limitation et modification',
    items: [
      'VoucherPro peut modifier, suspendre ou faire evoluer tout ou partie de la plateforme a tout moment afin de garantir sa securite, sa stabilite ou son adaptation technique.',
      'Les presentes conditions peuvent etre mises a jour a tout moment. La poursuite de l utilisation du service vaut acceptation de la version en vigueur.'
    ]
  }
];

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center justify-between gap-4">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-100"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour a la connexion
          </Link>

          <Link
            to="/privacy-policy"
            className="text-sm font-semibold text-blue-600 transition hover:text-blue-700"
          >
            Voir la politique de confidentialite
          </Link>
        </div>

        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <div className="mb-8 flex items-start gap-4">
            <div className="rounded-2xl bg-indigo-50 p-3 text-indigo-600">
              <FileText className="h-7 w-7" />
            </div>
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-600">
                VoucherPro
              </p>
              <h1 className="mt-2 text-3xl font-black text-slate-900">
                Conditions d utilisation
              </h1>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
                Ces conditions definissent les regles applicables a l acces et a l utilisation de la
                plateforme VoucherPro par les utilisateurs et les comptes revendeurs.
              </p>
              <p className="mt-3 text-xs font-medium text-slate-400">
                Derniere mise a jour : 08/07/2026
              </p>
            </div>
          </div>

          <div className="space-y-6">
            {sections.map((section) => (
              <section key={section.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <h2 className="text-lg font-bold text-slate-900">{section.title}</h2>
                <div className="mt-3 space-y-3">
                  {section.items.map((item) => (
                    <p key={item} className="text-sm leading-6 text-slate-600">
                      {item}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-indigo-100 bg-indigo-50 p-5">
            <h2 className="text-lg font-bold text-slate-900">Contact</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Pour toute question relative a ces conditions d utilisation, vous pouvez nous contacter a :
            </p>
            <a
              href="mailto:sofianetizi87@gmail.com"
              className="mt-3 inline-flex text-sm font-semibold text-indigo-600 transition hover:text-indigo-700"
            >
              sofianetizi87@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
